export default __webpack_public_path__ + "assets/images/642709d7d67745c181b97118c88ac706.svg";